const ContactUsHero = () => {
  const url = `https://wa.me/+2347055920000`;
  const socialLinks = [
    {
      icon: "/assets/images/facebook-icon.svg",
      alt: "Facebook",
      url: "https://www.facebook.com/share/1CcXtbiXRv/?mibextid=wwXIfr",
    },
    {
      icon: "/assets/images/x-twitter-icon.svg",
      alt: "Twitter",
      url: "https://x.com/homeandabroad_?s=21&t=Fp9DhHBu_uzqFrNMU1XAwg",
    },
    {
      icon: "/assets/images/instagram-icon.svg",
      alt: "Instagram",
      url: "https://www.instagram.com/homeandabroadng?igsh=MWdyOHljNGtqaDNq",
    },
    {
      icon: "/assets/images/linkedin-icon.svg",
      alt: "LinkedIn",
      url: "https://www.linkedin.com/in/home-and-abroad-86700337a",
    },
  ];
  return (
    <div className="flex flex-col gap-10 w-full">
      <section className="w-full bg-primary shadow-cardShadow py-10 lg:pt-5 lg:pb-10 px-6 lg:px-14 flex flex-col items-center justify-center gap-6">
        <h2 className="font-medium text-[28px] leading-[100%] text-white">
          Contact Us
        </h2>
        <span className="text-textWhite text-[16px] font-exo lg:text-[20px] leading-[22px] lg:leading-[32px] text-center max-w-[802px]">
          Choose the best way to get in touch. We’re always ready to discuss
          your project and answer any questions.
        </span>
      </section>
      <section className="grid md:grid-cols-2 gap-6 lg:grid-cols-4">
        <div className="p-12 xl:p-[42px] shadow-blurShadow items-center flex flex-col gap-2.5 rounded-lg bg-lightGray">
          <div className="rounded-full flex items-center justify-center bg-primary/30 size-[52px]">
            <img src="/assets/images/phone-icon.svg" alt="" />
          </div>
          <h3 className="text-primary text-[24px]">Call Us</h3>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="leading-[120%] text-textBlack3 text-[16px] tracking-[0]"
          >
            +234 705 592 0000
          </a>
          <a
            href={`tel:+2347055910000`}
            className="leading-[120%] text-textBlack3 text-[16px] tracking-[0]"
          >
            +234 705 591 0000
          </a>
        </div>
        <div className="p-12 xl:p-[42px] shadow-blurShadow items-center flex flex-col gap-2.5 rounded-lg bg-lightGray">
          <div className="rounded-full flex items-center justify-center bg-primary/30 size-[52px]">
            <img src="/assets/images/mail-icon.svg" alt="" />
          </div>
          <h3 className="text-primary text-[24px]">Email</h3>
          <a
            href="mailto:info@homeandabroad.ng"
            className="leading-[120%] text-textBlack3 text-[16px] tracking-[0]"
          >
            info@homeandabroad.ng
          </a>

          <a
            href="mailto:support@homeandabroad.ng"
            className="leading-[120%] text-textBlack3 text-[16px] tracking-[0]"
          >
            support@homeandabroad.ng
          </a>
        </div>
        <div className="p-12 xl:p-[42px] shadow-blurShadow items-center flex flex-col gap-2.5 rounded-lg bg-lightGray">
          <div className="rounded-full flex items-center justify-center bg-primary/30 size-[52px]">
            <img src="/assets/images/globe-icon.svg" alt="" />
          </div>
          <h3 className="text-primary text-[24px]">Socials</h3>
          <div className="flex items-center gap-[6.65px]">
            {socialLinks.map((social, idx) => (
              <a
                key={idx}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="size-7 rounded bg-[#33333314] flex items-center justify-center hover:bg-[#33333325] transition"
              >
                <img
                  src={social.icon}
                  alt={social.alt}
                  className="h-[12.92px]"
                />
              </a>
            ))}
          </div>
        </div>
        <div className="p-12 xl:p-[42px] shadow-blurShadow items-center flex flex-col gap-2.5 rounded-lg bg-lightGray">
          <div className="rounded-full flex items-center justify-center bg-primary/30 size-[52px]">
            <img src="/assets/images/office-icon.svg" alt="" />
          </div>
          <h3 className="text-primary text-[24px]">Our Office</h3>
          <span className="font-exo text-[16px] leading-[100%] tracking-[0] text-center text-textBlack3">
            Plot 1422, Independence Avenue, Central Business District, Abuja.
          </span>
        </div>
      </section>
    </div>
  );
};

export default ContactUsHero;
